/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Model from 'fierry/rpc.old/model';

import General from 'astro/server/constants/general';

import Projectile from 'astro/server/constants/projectile';
import Building from 'astro/server/constants/building';
import Entity from 'astro/server/constants/entity';
import Theme from 'astro/server/constants/theme';
import Unit from 'astro/server/constants/unit';


export default class extends Model
{
  constructor (state, hierarchy)
  {
    super(state, hierarchy);

    this.projectiles = new Map();
    this.entities = new Map();
    this.buildings = new Map();
    this.themes = new Map();
    this.units = new Map();

    this.general = new General();

    for (const constants of this.state.get('projectiles').values())
    {
      this.projectiles.set(constants.type, new Projectile({ constants }));
    }

    for (const cass of this.state.get('entities').values())
    {
      this.entities.set(cass.variant, new Entity(cass));
    }

    for (const constants of this.state.get('buildings').values())
    {
      this.buildings.set(constants.type, new Building({ constants }));
    }

    for (const constants of this.state.get('themes').values())
    {
      this.themes.set(constants.type, new Theme({ constants }));
    }

    for (const constants of this.state.get('units').values())
    {
      this.units.set(constants.type, new Unit({ constants }));
    }
  }


  getProjectile (type)
  {
    return this.projectiles.get(type);
  }


  getSpaceship (type)
  {
    return this.spaceships.get(type);
  }


  getEntity (variant)
  {
    return this.entities.get(variant);
  }


  getBuilding (type)
  {
    return this.buildings.get(type);
  }


  getTheme (type)
  {
    return this.themes.get(type);
  }


  getUnit (type)
  {
    return this.units.get(type);
  }


  getGeneral ()
  {
    return this.general;
  }


}
